<template>
  <div class="checkout-area">
    <b-button class="close-button" @click="closeShop()"
      >{{ $t("close") }}
    </b-button>
    <iframe
      allow="fullscreen"
      :src="url"
      :height="widget.height"
      :width="widget.width"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: "CheckoutPage",
  props: {
    url: String,
    widget: Object,
    game: String
  },
  data() {
    return {};
  },
  methods: {
    closeShop() {
      this.$emit("close");
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.checkout-area {
  background-color: white;
  width: 100%;
  height: 100%;
}
</style>
